import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { HttpParams } from "@angular/common/http";
import { Quote } from "../quote.type";
import { QuoteRepository } from "../quote.repository";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface CarrierChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-quote-variant-select",
  styleUrls: ["./quote-variant-select.component.scss"],
  templateUrl: "./quote-variant-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class QuoteVariantSelectComponent implements OnInit, OnChanges {
  private quoteRepository = inject(QuoteRepository);

  @Input() public quote: Quote;
  readonly quoteChange = output<Quote>();

  public subscription = new Subscription();
  public quoteList: SelectItem[] = [];

  ngOnInit() {
    this.buildQuoteList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quote && !changes.quote.firstChange) {
      // IF quote is not on the list:
      let isNewQuote = true;
      this.quoteList.forEach((item) => {
        if (item.value.getId() == changes.quote.currentValue.getId()) {
          isNewQuote = false;
        }
      });
      if (isNewQuote) {
        this.buildQuoteList();
      }
    }
  }

  public onQuoteChange(event: CarrierChangeEvent) {
    this.quoteChange.emit(this.quote);
  }

  private buildQuoteList(): void {
    let params = new HttpParams();
    params = params.append("criteria[groupId]", this.quote.getGroupId());

    this.quoteRepository.getQuoteList(params).subscribe((quoteList) => {
      this.quoteList = [];
      quoteList.items.forEach((quote) => {
        this.quoteList.push({ label: quote.getDisplayId(), value: quote });
      });
    });
  }
}
